export const exportToCsv = (gridApi) => {
  return gridApi.exportDataAsCsv()
}

export const duplicateSelectedRows = (gridApi, callback) => {
  const selectedRows = gridApi.getSelectedRows()
  if (!selectedRows || selectedRows.length === 0) {
    console.log('No rows selected!')
    return
  }
  return addRows(gridApi, selectedRows, callback)
}

export const deleteSelectedRows = (gridApi, callback) => {
  const selectedNodes = gridApi.getSelectedNodes()
  const selectedData = selectedNodes.map((node) => node.data)

  if (!selectedNodes || selectedNodes.length === 0) {
    console.log('No rows selected!')
    return
  }
  gridApi.applyTransaction({ remove: selectedData })

  if (callback) {
    callback(selectedNodes, selectedData)
  }
}

export const addRows = (gridApi, newItems = [], callback) => {
  gridApi.applyTransaction({ add: newItems })
  if (callback) {
    callback(newItems)
  }
}

export const addRow = (gridApi, rowData = {}, callback) => {
  return addRows(gridApi, [rowData], callback)
}

export const selectAllRows = (gridApi) => {
  gridApi && gridApi.selectAll()
}

export const clearData = (gridApi) => {
  gridApi.setRowData([])
}

export const setQuickFilter = (gridApi, filter) => {
  gridApi.setQuickFilter(filter)
}

export const PinnedRowTop = (gridApi) => {
  const selectedRows = gridApi.getSelectedRows()

  if (!selectedRows || selectedRows.length === 0) {
    console.log('No rows selected!')
    return
  }

  return gridApi.setPinnedTopRowData(selectedRows)
}
export const PinnedRowBottom = (gridApi) => {
  const selectedRows = gridApi.getSelectedRows()
  if (!selectedRows || selectedRows.length === 0) {
    console.log('No rows selected!')
    return
  }

  return gridApi.setPinnedBottomRowData(selectedRows)
}

export const sizeToFit = (gridApi) => {
  gridApi.sizeColumnsToFit()
}

export const autoSizeAll = (skipHeader, columnApi) => {
  const allColumnIds = []
  columnApi.getAllColumns().forEach((column) => {
    allColumnIds.push(column.colId)
  })
  columnApi.autoSizeColumns(allColumnIds, skipHeader)
}
